<div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 2%;">
        <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint [useExistingCss]="true"> Print </button>
        <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div class="wrapper">
            <!-- Header Section -->
            <div class="row rowborder hc px-5">
                <div class="common">
                    <span>दिनांक : {{ getFormattedDate() }}</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>पृष्ठ क्र : 1</span>
                </div>
                <div class="common text-center" style="color: red;">
                    <span>हिंदुस्थान प्रकाशन संस्था</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>बँक रीकन्सिलीएशन अहवाल</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>{{bank}}</span>
                </div>
                <div class="common text-right">
                    <span>दिनांक पासून : {{ startDate | date: 'dd-MM-yyyy' }}</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>दिनांक पर्यंत : {{ endDate | date: 'dd-MM-yyyy' }}</span>
                </div>
            </div>

            <!-- Table Header -->
            <div class="row rowborder px-5">
                <div class="col-3 text-center"><span class="fw_600">तपशील</span></div>
                <div class="col-3 text-right"><span class="fw_600 mr-3">डेबिट</span></div>
                <div class="col-3 text-right"><span class="fw_600 mr-3">क्रेडिट</span></div>
                <div class="col-3 text-right"><span class="fw_600 mr-3">शिल्लक</span></div>
            </div>
            <!-- 1) आरंभ संख्या -->
            <div class="row rowborder px-5 hc2">
                <div class="col-3 fw_600" style="margin-left:-32px">१) आरंभ संख्या</div>

                <!-- 2nd Column: Show Dr amount only -->
                <div class="col-3 fw_600 text-right">
                    <span *ngIf="dr_opening_bal != 0">{{ dr_opening_bal | number:'1.2-2' }}</span>
                </div>

                <!-- 3rd Column: Show Cr amount only -->
                <div class="col-3 fw_600 text-right">
                    <span *ngIf="cr_opening_bal != 0">{{ cr_opening_bal | number:'1.2-2' }}</span>
                </div>

                <div class="col-3 fw_600 text-right">
                    <span *ngIf="dr_opening_bal != 0">{{ dr_opening_bal | number:'1.2-2' }} Dr</span>
                    <span *ngIf="cr_opening_bal != 0">{{ cr_opening_bal | number:'1.2-2' }} Cr</span>
                </div>
            </div>

            <!-- 2) कालावधीत मंजुरी मिळालेल्या जमा रकमा -->
            <div class="row rowborder">
                <div class="col-12 fw_600 hc2">२) कालावधीत मंजुरी मिळालेल्या जमा रकमा</div>
            </div>

            <div *ngFor="let item of category2_crApproved; let last = last">
                <div class="row px-5">
                    <div class="col-3">
                        <span>{{ item.voucher_no }}</span> |
                        <span>{{ item.voucher_date }}</span><br>
                        <span>{{ item.rep_name }}</span>
                    </div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'CR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'DR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3"></div>
                    <div class="col-3 text-right">
                        {{ item.running_balance | number:'1.2-2' }}
                    </div>
                </div>

                <!-- ✅ Call method to store last balance -->
                <ng-container *ngIf="last">
                    {{ setLastRunningBalance2(item.running_balance) }}
                </ng-container>
            </div>

            <!-- Fallback when array is empty -->
            <ng-container *ngIf="category2_crApproved.length === 0">
                {{ setLastRunningBalance2(dr_opening_bal || cr_opening_bal || 0) }}
            </ng-container>

            <!-- ✅ Total Row -->
            <div class="row px-5 mt-2" style="background-color: yellow;">
                <div class="col-3 fw_600">एकूण:</div>
                <div class="col-3 text-right fw_600">{{ category2Total | number:'1.2-2' }}</div>
                <div class="col-3"></div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance2 < 0">
                    {{ getAbsoluteBalance(lastRunningBalance2) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance2) }} </div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance2 >= 0">
                    {{ getAbsoluteBalance(lastRunningBalance2) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance2) }}
                </div>
            </div>

            <!-- 3) कालावधीत मंजुरी मिळालेल्या देय रकमा -->
            <div class="row rowborder">
                <div class="col-12 fw_600 hc2">३) कालावधीत मंजुरी मिळालेल्या देय रकमा</div>
            </div>

            <div *ngFor="let item of category3_drApproved; let last = last">
                <div class="row px-5">
                    <div class="col-3">
                        <span>{{ item.voucher_no }}</span> |
                        <span>{{ item.voucher_date }}</span><br>
                        <span>{{ item.rep_name }}</span>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'CR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'DR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3 text-right">
                        {{ item.running_balance | number:'1.2-2' }}
                    </div>
                </div>

                <ng-container *ngIf="last">
                    {{ setLastRunningBalance3(item.running_balance) }}
                </ng-container>
            </div>

            <!-- Fallback when array is empty -->
            <ng-container *ngIf="category3_drApproved.length === 0">
                {{ setLastRunningBalance3(currentBalance) }}
            </ng-container>

            <div class="row px-5 mt-2" style="background-color: yellow;">
                <div class="col-3 fw_600">एकूण:</div>
                <div class="col-3"></div>
                <div class="col-3 text-right fw_600">{{ category3Total | number:'1.2-2' }}</div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance3 < 0">
                    {{ getAbsoluteBalance(lastRunningBalance3) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance3) }} </div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance3 >= 0">
                    {{ getAbsoluteBalance(lastRunningBalance3) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance3) }}
                </div>
            </div>

            <!-- 4) कालावधीत मंजुरी मिळणे बाकी जमा रकमा -->
            <div class="row rowborder">
                <div class="col-12 fw_600 hc2">४) कालावधीत मंजुरी मिळणे बाकी जमा रकमा</div>
            </div>

            <div *ngFor="let item of category4_crPending; let last = last">
                <div class="row px-5">
                    <div class="col-3">
                        <span>{{ item.voucher_no }}</span> |
                        <span>{{ item.voucher_date }}</span><br>
                        <span>{{ item.rep_name }}</span>
                    </div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'CR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'DR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3"></div>
                    <div class="col-3 text-right">
                        {{ item.running_balance | number:'1.2-2' }}
                    </div>
                </div>

                <ng-container *ngIf="last">
                    {{ setLastRunningBalance4(item.running_balance) }}
                </ng-container>
            </div>

            <!-- Fallback when array is empty -->
            <ng-container *ngIf="category4_crPending.length === 0">
                {{ setLastRunningBalance4(currentBalance) }}
            </ng-container>

            <div class="row px-5 mt-2" style="background-color: yellow;">
                <div class="col-3 fw_600">एकूण:</div>
                <div class="col-3 text-right fw_600">{{ category4Total | number:'1.2-2' }}</div>
                <div class="col-3"></div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance4 < 0">
                    {{ getAbsoluteBalance(lastRunningBalance4) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance4) }} </div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance4 >= 0">
                    {{ getAbsoluteBalance(lastRunningBalance4) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance4) }}
                </div>
            </div>

            <!-- 5) कालावधीत मंजुरी मिळणे बाकी देय रकमा -->
            <div class="row rowborder">
                <div class="col-12 fw_600 hc2">५) कालावधीत मंजुरी मिळणे बाकी देय रकमा</div>
            </div>

            <div *ngFor="let item of category5_drPending; let last = last">
                <div class="row px-5">
                    <div class="col-3">
                        <span>{{ item.voucher_no }}</span> |
                        <span>{{ item.voucher_date }}</span><br>
                        <span>{{ item.rep_name }}</span>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'CR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3 text-right" *ngIf="item.voucher_type == 'DR'">
                        {{ item.deposit_amt | number:'1.2-2' }}
                    </div>
                    <div class="col-3 text-right">
                        {{ item.running_balance | number:'1.2-2' }}
                    </div>
                </div>

                <ng-container *ngIf="last">
                    {{ setLastRunningBalance5(item.running_balance) }}
                </ng-container>
            </div>

            <ng-container *ngIf="category5_drPending.length === 0">
                {{ setLastRunningBalance5(currentBalance) }}
            </ng-container>

            <div class="row px-5 mt-2" style="background-color: yellow;">
                <div class="col-3 fw_600">एकूण:</div>
                <div class="col-3"></div>
                <div class="col-3 text-right fw_600">{{ category5Total | number:'1.2-2' }}</div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance5 < 0">
                    {{ getAbsoluteBalance(lastRunningBalance5) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance5) }} </div>
                <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance5 >= 0">
                    {{ getAbsoluteBalance(lastRunningBalance5) | number:'1.2-2' }} {{
                    getBalanceLabel(lastRunningBalance5) }}
                </div>
            </div>

        </div>

        <div class="row px-5 mt-3" style="background-color: red;font-size: 18px;color: aliceblue;">
            <div class="col-3 fw_600">सर्वांची एकुण:</div>
            <div class="col-3 text-right fw_600">{{ drTotal | number:'1.2-2' }}</div>
            <div class="col-3 text-right fw_600">{{ crTotal | number:'1.2-2' }}</div>
            <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance5 < 0">
                {{ getAbsoluteBalance(lastRunningBalance5) | number:'1.2-2' }} {{
                getBalanceLabel(lastRunningBalance5) }} </div>
            <div class="col-3 text-right fw_600" *ngIf="lastRunningBalance5 >= 0">
                {{ getAbsoluteBalance(lastRunningBalance5) | number:'1.2-2' }} {{
                getBalanceLabel(lastRunningBalance5) }}
            </div>
        </div>

    </div>